


function Loading(props) {

  return (
    <div className={`iol-overlay ${props.loadingState} `} >
			<div className="iol-overlay-content">
				{/*<div className="closebtn">
					<div className="icon-close"></div>
  				</div>*/}
				<div className="iol-wrapper">
					<div className="iol-waiting-content">
						<div className="iol-waiting-upper-text">
							<div className="large-title">Stiamo caricando i dati necessari!</div><p>Tra poco potrai procedere con la tua richiesta.</p>
						</div>
						<div className="iol-waiting-progress-bar">
							<div className="iol-waiting-progress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
						</div><p className="heading-6 semibold"> </p>
					</div>
				</div>
				{/*<a className="iol-back" href="#"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNTA1MiAyNC43OTVDMTYuNzc4NiAyNS4wNjgzIDE3LjIyMTggMjUuMDY4MyAxNy40OTUyIDI0Ljc5NUMxNy43Njg1IDI0LjUyMTYgMTcuNzY4NSAyNC4wNzg0IDE3LjQ5NTIgMjMuODA1TDEyLjM5MDEgMTguN0wyNS43NTAyIDE4LjdDMjYuMTM2OCAxOC43IDI2LjQ1MDIgMTguMzg2NiAyNi40NTAyIDE4QzI2LjQ1MDIgMTcuNjEzNCAyNi4xMzY4IDE3LjMgMjUuNzUwMiAxNy4zTDEyLjM5MDEgMTcuM0wxNy40OTUyIDEyLjE5NUMxNy43Njg1IDExLjkyMTYgMTcuNzY4NSAxMS40Nzg0IDE3LjQ5NTIgMTEuMjA1QzE3LjIyMTggMTAuOTMxNyAxNi43Nzg2IDEwLjkzMTcgMTYuNTA1MiAxMS4yMDVMMTAuMjA1MiAxNy41MDVDOS45MzE4NSAxNy43Nzg0IDkuOTMxODUgMTguMjIxNiAxMC4yMDUyIDE4LjQ5NUwxNi41MDUyIDI0Ljc5NVoiIGZpbGw9IiNERTFFNjMiLz4NCjxjaXJjbGUgY3g9IjE4IiBjeT0iMTgiIHI9IjE3LjUiIHN0cm9rZT0iI0RFMUU2MyIvPg0KPC9zdmc+DQo=" />Torna indietro</a>*/ }
			</div>
			<div className="iol-progress-bar">
				<div className="iol-progress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style={{width: "20%"}}></div>
			</div>
		</div>
  );
}

export default Loading;
